import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const useScrollToHash = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      // Remove the # from the hash
      const sectionId = location.hash.substring(1);
      
      // Use longer timeout for lazy-loaded components
      const timeoutId = setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          // Add offset for fixed headers
          const headerOffset = 80;
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }, 300); // Increased timeout for lazy loading

      return () => clearTimeout(timeoutId);
    }
  }, [location.hash, location.pathname]); // Also depend on pathname for page changes
};

export default useScrollToHash;